import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { FieldComponent, FormComponent, InputComponent, InputValidators } from '@swissfex/sfx-commons';

import { DEFAULT_ICONS, ProjectVersionDescriptionMask } from '../../../constants';
import { unregisterSfxStatusChanges } from '../../../core/utils/utils';
import { ICloneProjectPayload } from '../../models/ICloneProjectPayload';

interface ICreateProjectVersionFormGroup {
    versionDescription: FormControl<string>;
}

@Component({
    selector: 'app-create-project-version-modal-content',
    templateUrl: './create-project-version-modal-content.component.html',
    styleUrl: './create-project-version-modal-content.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FieldComponent, FormComponent, InputComponent, TranslatePipe]
})
export class CreateProjectVersionModalContentComponent implements OnInit, OnDestroy {
    protected formGroup = signal<FormGroup<ICreateProjectVersionFormGroup>>(undefined);

    protected readonly descriptionInfoIcon = {
        name: DEFAULT_ICONS.MORE_INFO,
        message: 'project.version_description.info'
    };
    protected readonly descriptionClearIcon = {
        name: DEFAULT_ICONS.CLEAR_INPUT,
        action: () => {
            this.formGroup().controls.versionDescription.setValue(null);
        }
    };
    protected readonly lengthLimitMask = ProjectVersionDescriptionMask;

    public get formValue(): ICloneProjectPayload {
        return this.formGroup().getRawValue();
    }

    public ngOnInit(): void {
        this.setupFormGroup();
    }

    public ngOnDestroy(): void {
        unregisterSfxStatusChanges(this.formGroup());
    }

    private setupFormGroup(): void {
        this.formGroup.set(
            new FormGroup({
                versionDescription: new FormControl(null, InputValidators.maxLength(25))
            }).setDisplayErrorsOn('dirty')
        );
    }
}
